





























































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import moment from "moment";

@Component
export default class ScheduleGrid extends Vue {
  // eslint-disable-next-line
  @Prop({ default: () => [] }) days!: any[];
  // eslint-disable-next-line
  @Prop({ default: () => [] }) employees!: any[];
  // eslint-disable-next-line
  @Prop({ default: () => [] }) schedules!: any[];
  // eslint-disable-next-line
  @Prop({ default: () => [] }) vacations!: any[];
  // eslint-disable-next-line
  @Prop({ default: () => [] }) timeOffRequests!: any[];
  @Prop({ default: "CNA Day" }) groupName!: string;
  // eslint-disable-next-line
  @Prop({ default: () => [] }) shifts!: { id: number; shift: string }[];

  isPastDate(dateStr: string): boolean {
    if (!dateStr) return false;
    return moment(dateStr, "YYYY-MM-DD").isBefore(moment(), "day");
  }

  // eslint-disable-next-line
  isSchedPpdOver(day: any): boolean {
    if (day.schedPpd == null || day.targetPpd == null) return false;
    const sched = parseFloat(day.schedPpd);
    const target = parseFloat(day.targetPpd);
    return !isNaN(sched) && !isNaN(target) && sched >= target + 0.1;
  }

  // eslint-disable-next-line
  isActualPpdOver(day: any): boolean {
    if (day.actualPpd == null || day.targetPpd == null) return false;
    const actual = parseFloat(day.actualPpd);
    const target = parseFloat(day.targetPpd);
    return !isNaN(actual) && !isNaN(target) && actual >= target + 0.1;
  }

  get mtdAvgCensus(): string {
    const validValues = this.days
      .map(d => parseFloat(d.census))
      .filter(v => !isNaN(v) && v !== 0);
    if (!validValues.length) return "-";
    const sum = validValues.reduce((acc, curr) => acc + curr, 0);
    return (sum / validValues.length).toFixed(1);
  }

  get mtdAvgTargetPpd(): string {
    const validValues = this.days
      .map(d => parseFloat(d.targetPpd))
      .filter(v => !isNaN(v) && v !== 0);
    if (!validValues.length) return "-";
    const sum = validValues.reduce((acc, curr) => acc + curr, 0);
    return (sum / validValues.length).toFixed(2);
  }

  get mtdAvgSchedPpd(): string {
    const validValues = this.days
      .map(d => parseFloat(d.schedPpd))
      .filter(v => !isNaN(v) && v !== 0);
    if (!validValues.length) return "-";
    const sum = validValues.reduce((acc, curr) => acc + curr, 0);
    return (sum / validValues.length).toFixed(2);
  }

  get mtdAvgActualPpd(): string {
    const validValues = this.days
      .map(d => parseFloat(d.actualPpd))
      .filter(v => !isNaN(v) && v !== 0);
    if (!validValues.length) return "-";
    const sum = validValues.reduce((acc, curr) => acc + curr, 0);
    return (sum / validValues.length).toFixed(2);
  }

  get mtdAvgTotalSchedules(): string {
    const validValues = this.days
      .map(d => parseFloat(d.totalCount))
      .filter(v => !isNaN(v) && v !== 0);
    if (!validValues.length) return "-";
    const sum = validValues.reduce((acc, curr) => acc + curr, 0);
    return sum.toString();
  }

  // eslint-disable-next-line
  get groupedEmployees(): { label: string; employees: any[] }[] {
    const shiftMap: Record<number, string> = {};
    for (const s of this.shifts) {
      shiftMap[s.id] = s.shift;
    }

    // eslint-disable-next-line
    const groupMap: Record<string, any[]> = {};
    for (const emp of this.employees) {
      const t = emp.title || "Unknown";
      const shiftName =
        (emp.shift != null && shiftMap[emp.shift]) || "No Shift";
      const label = `${t} ${shiftName}`;
      if (!groupMap[label]) groupMap[label] = [];
      groupMap[label].push(emp);
    }

    return Object.entries(groupMap)
      .sort(([a], [b]) => a.localeCompare(b))
      .map(([label, employees]) => ({ label, employees }));
  }

  selectedFilterDate: string | null = null;

  toggleDateFilter(date: string) {
    if (this.selectedFilterDate === date) {
      this.selectedFilterDate = null;
      this.$emit("filter-total", undefined);
      return;
    }
    this.selectedFilterDate = date;
    this.$emit("filter-total", date);
  }

  getSchedule(employeeId: number, date: string) {
    const match = this.schedules.find(
      s => s.employeeId === employeeId && s.date === date,
    );
    if (!match) return null;
    return match;
  }

  // eslint-disable-next-line
  getVacation(employeeId: number, date: string): any | null {
    return (
      this.vacations.find(
        // eslint-disable-next-line
        (v: any) => v.employeeId === employeeId && v.date === date,
      ) || null
    );
  }

  /** Returns a pending time-off request for this emp+date, if any. */
  // eslint-disable-next-line
  getPendingTimeOff(employeeId: number, date: string): any | null {
    return (
      this.timeOffRequests.find(
        // eslint-disable-next-line
        (r: any) =>
          r.employeeId === employeeId &&
          r.date === date &&
          r.status === "pending",
      ) || null
    );
  }

  /** Returns an accepted time-off request for this emp+date, if any. */
  // eslint-disable-next-line
  getAcceptedTimeOff(employeeId: number, date: string): any | null {
    return (
      this.timeOffRequests.find(
        // eslint-disable-next-line
        (r: any) =>
          r.employeeId === employeeId &&
          r.date === date &&
          r.status === "accepted",
      ) || null
    );
  }

  getScheduleStyle(employeeId: number, date: string) {
    const sched = this.getSchedule(employeeId, date);
    if (!sched) return {};

    let statusColor = "#2196f3"; // ASSIGNED default (blue)
    const statusStr = (sched.data?.status || "").toUpperCase();

    if (sched.data?.isUrgent) {
      statusColor = "#f44336"; // urgent always wins — red
    } else if (sched.data?.overtime) {
      statusColor = "#f59e0b"; // overtime — amber
    } else if (statusStr === "PENDING" || statusStr === "PENDING_APPROVAL") {
      statusColor = "#ff9800";
    } else if (statusStr === "APPROVED") {
      statusColor = "#4caf50";
    } else if (statusStr === "UNAVAILABLE") {
      statusColor = "#9c27b0";
    } else if (statusStr === "OPEN") {
      statusColor = "#00bcd4";
    } else if (statusStr === "CALLED_OFF" || statusStr === "CANCELLED") {
      statusColor = "#f44336";
    }

    return {
      backgroundColor: statusColor + "20",
      borderLeft: `4px solid ${statusColor}`,
    };
  }

  // eslint-disable-next-line
  getSchedPpdTooltip(day: any): string {
    if (
      !day ||
      day.census == null ||
      day.schedPpd == null ||
      day.targetPpd == null
    )
      return "";
    const census = parseFloat(day.census);
    const schedPpd = parseFloat(day.schedPpd);
    const targetPpd = parseFloat(day.targetPpd);
    if (isNaN(census) || isNaN(schedPpd) || isNaN(targetPpd) || census === 0)
      return "";

    const schedHours =
      day.actualWorkHour != null
        ? Number(day.actualWorkHour)
        : schedPpd * census;
    const targetHours = targetPpd * census;
    const diff = schedHours - targetHours;

    const diffText =
      diff > 0
        ? `${diff.toFixed(1)} hours over target`
        : diff < 0
        ? `${Math.abs(diff).toFixed(1)} hours under target`
        : "on target";

    return `Scheduled Hours: ${schedHours.toFixed(
      1,
    )} (Target: ${targetHours.toFixed(1)}) — ${diffText}`;
  }

  // eslint-disable-next-line
  getActualPpdTooltip(day: any): string {
    if (
      !day ||
      day.census == null ||
      day.actualPpd == null ||
      day.targetPpd == null
    )
      return "";
    const census = parseFloat(day.census);
    const actualPpd = parseFloat(day.actualPpd);
    const targetPpd = parseFloat(day.targetPpd);
    if (isNaN(census) || isNaN(actualPpd) || isNaN(targetPpd) || census === 0)
      return "";

    const actualHours = actualPpd * census;
    const targetHours = targetPpd * census;
    const diff = actualHours - targetHours;

    const diffText =
      diff > 0
        ? `${diff.toFixed(1)} hours over target`
        : diff < 0
        ? `${Math.abs(diff).toFixed(1)} hours under target`
        : "on target";

    return `Actual Hours: ${actualHours.toFixed(
      1,
    )} (Target: ${targetHours.toFixed(1)}) — ${diffText}`;
  }
}
